import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PmsComponent } from './pms/pms.component';
import { EmployeeMasterComponent } from './employee-master/employee-master.component';
import { ImportFilesComponent } from './import-files/import-files.component';
import { ProfileManagementComponent } from './profile-management/profile-management.component';
import { ImportHistoryComponent } from './import-history/import-history.component';
import { HrAdminMyHomeComponent } from './hr-admin-my-home/hr-admin-my-home.component';
import { PmsDashboardComponent } from './pms-dashboard/pms-dashboard.component';
import { AdminAccessMatrixComponent } from './admin-access-matrix/admin-access-matrix.component';
import { CompetencyManagementComponent } from './competency-management/competency-management.component';
import { IncrementComponent } from './increment/increment.component';
import { AuditLogsComponent } from './audit-logs/audit-logs.component';
import { TaskManagementsComponent } from './task-managements/task-managements.component';
import { CompetencyHistoryComponent } from './competency-history/competency-history.component';
import { IncrementLetterComponent } from './increment-letter/increment-letter.component';
import { EmailContentComponent } from './email-content/email-content.component';
import { UploadfileComponent } from './uploadfile/uploadfile.component';
import { GenerateIncrementLettersComponent } from './generate-increment-letters/generate-increment-letters.component';
import { VariablePayComponent } from './variable-pay/variable-pay.component';
import { VariablePayEmailContentComponent } from './variable-pay-email-content/variable-pay-email-content.component';
import { VariablePayLetterComponent } from './variable-pay-letter/variable-pay-letter.component';
import { VariablePayUploadfileComponent } from './variable-pay-uploadfile/variable-pay-uploadfile.component';
import { VariablePayLogsComponent } from './variable-pay-logs/variable-pay-logs.component';
import { GenerateVariablePayLettersComponent } from './generate-variable-pay-letters/generate-variable-pay-letters.component';
import { OrganizationalStructureComponent } from './organizational-structure/organizational-structure.component';
import { IncrementLogsComponent } from './increment-logs/increment-logs.component';
import { ESSComponent } from './ess/ess.component';
import { EssLogsComponent } from './ess-logs/ess-logs.component';
import { ThreeSixtyDegreeComponent } from './three-sixty-degree/three-sixty-degree.component';
import { ThreeSixtyDegreeLogsComponent } from './three-sixty-degree-logs/three-sixty-degree-logs.component';
import { ExpenseComponent } from './expense/expense.component';
import { ExpenceLogsComponent } from './expence-logs/expence-logs.component';
import { AssestManagementComponent } from './assest-management/assest-management.component';
import { AssetErrorLogComponent } from './asset-error-log/asset-error-log.component';
import { NineBoxComponent } from './9Box/nine-box/nine-box.component';
import { NineBoxLogComponent } from './9Box/nine-box-log/nine-box-log.component';
import { ElcmComponent } from './ELCM/elcm/elcm.component';
import { AttritiontabsComponent } from './Attrition/attritiontabs/attritiontabs.component';
import { AttritionDemographicComponent } from './Attrition/attrition-demographic/attrition-demographic.component';
import { AttritionScoreExpWiseComponent } from './Attrition/attrition-score-exp-wise/attrition-score-exp-wise.component';
import { AttritionSalaryLeaveWiseComponent } from './Attrition/attrition-salary-leave-wise/attrition-salary-leave-wise.component';
import { AttritionsetupComponent } from './Attrition/attritionsetup/attritionsetup.component';
import { AttritionLogsComponent } from './Attrition/attrition-logs/attrition-logs.component';
import { LNDComponent } from './Learning-n-Development/l-n-d/l-n-d.component';
import { LndSetupComponent } from './Learning-n-Development/lnd-setup/lnd-setup.component';
import { NineBoxDashboardComponent } from './9Box/nine-box-dashboard/nine-box-dashboard.component';

const routes: Routes = [
  {
    path: 'pms',
    component: PmsComponent,
  },
  {
    path: 'employeemaster',
    component: EmployeeMasterComponent,
  },
  {
    path: 'importFiles',
    component: ImportFilesComponent,
  },
  {
    path: 'importHistory',
    component: ImportHistoryComponent,
  },
  {
    path: 'profileManagement',
    component: ProfileManagementComponent,
  },
  {
    path: 'myhome',
    component: HrAdminMyHomeComponent,
  },
  {
    path: 'accessmatrix',
    component: AdminAccessMatrixComponent
  },
  {
    path : 'competency',
    component :CompetencyManagementComponent
  },
  {
    path : 'increment',
    component :IncrementComponent
  },
  {
    path : 'auidtlogs',
    component :AuditLogsComponent
  },
  {
    path : 'taskmanagements',
    component :TaskManagementsComponent
  },
  {
    path : 'coompetencyHistory',
    component : CompetencyHistoryComponent
  },
  {
    path : 'incrementLetter',
    component :IncrementLetterComponent
  },
  {
    path : 'increment/emailContent',
    component :EmailContentComponent
  },
  {
    path : 'increment/uploadfile',
    component :UploadfileComponent
  },
  {
    path : 'increment/generateIncrementLetters',
    component :GenerateIncrementLettersComponent
  },
  {
    path : 'incrementLogs',
    component :IncrementLogsComponent
  },
  {
    path: 'variablepay',
    component: VariablePayComponent
  },
  {
    path: 'variablepay/variablepayEmailContent',
    component: VariablePayEmailContentComponent
  },
  {
    path: 'variablepay/variablepayLetter',
    component: VariablePayLetterComponent
  },
  {
    path : 'variablepayUploadFile',
    component :VariablePayUploadfileComponent
  },
  {
    path: 'variablepay/variablePayLogs',
    component: VariablePayLogsComponent
  },
  {
    path: 'variablepay/generateVariablePayLetter',
    component: GenerateVariablePayLettersComponent
  },
  {
    path: 'organizationalStructure',
    component: OrganizationalStructureComponent
  },
  {
    path: 'ess',
    component: ESSComponent
  },
  {
    path: 'essLogs',
    component: EssLogsComponent
  },
  {
    path: 'threeSixtyDegree',
    component: ThreeSixtyDegreeComponent
  },
 
  {
    path: 'threeSixtyDegree/logs',
    component: ThreeSixtyDegreeLogsComponent
  },
  {
    path: 'expense',
    component: ExpenseComponent
  },
  {
    path: 'expense-logs',
    component: ExpenceLogsComponent
  },
  {
    path: 'asset-management',
    component: AssestManagementComponent
  },
  {
    path: 'asset-logs',
    component: AssetErrorLogComponent
  },
  /* {
    path: 'nine-box',
    component: NineBoxComponent
  }, */
  {
    path: 'nineBox',
    component: NineBoxComponent,
  },
  {
    path:'ninebox-log',
    component:NineBoxLogComponent
  },
  {
    path: 'elcm',
    component: ElcmComponent
  },
  {
    path: 'attrition',
    component: AttritiontabsComponent
  },
  {
    path: 'attrition',
    component: AttritionDemographicComponent
  },

  {
    path: 'attrition',
    component: AttritionScoreExpWiseComponent
  },
  {
    path: 'attrition',
    component: AttritionSalaryLeaveWiseComponent
  },
  {
    path: 'attrition-setup',
    component: AttritionsetupComponent
  },
  {
    path: 'attrition-logs',
    component: AttritionLogsComponent
  },

  {
    path: 'lnd',
    component: LNDComponent
  },

  {
    path: 'lnd-setup',
    component: LndSetupComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HradminRoutingModule { }
